import { Tag, TagProps } from 'bold-ui'
import { red } from 'bold-ui/lib/styles/colors'
import React, { useMemo } from 'react'

import { EstratificacaoRastreamentoEnum } from '../model-rastreamentos'

interface RastreamentosEstratificacaoTagProps {
  estratificacao: EstratificacaoRastreamentoEnum
}

export function RastreamentosEstratificacaoTag(props: Readonly<RastreamentosEstratificacaoTagProps>) {
  const { estratificacao } = props

  const tagProps = useMemo((): TagProps => {
    switch (estratificacao) {
      case EstratificacaoRastreamentoEnum.MUITO_ALTO_RISCO:
        return {
          style: {
            backgroundColor: red.c20,
            color: red.c100,
          },
        }
      case EstratificacaoRastreamentoEnum.ALTO_RISCO:
        return { type: 'danger' }
      case EstratificacaoRastreamentoEnum.MODERADO_RISCO:
      case EstratificacaoRastreamentoEnum.BAIXO_RISCO:
        return { type: 'alert' }
      default:
        return null
    }
  }, [estratificacao])

  if (!tagProps) {
    return null
  }

  return <Tag {...tagProps}>{estratificacao}</Tag>
}
